import { Box } from '@mui/material';

import { STATUS_COLOR } from '~/components/tasks/taskStyle';
import type { TaskStatus } from '~/data/generated/model';

export function StatusChip({
  status,
  size = 'medium',
}: {
  status: Pick<TaskStatus, 'name' | 'color'>;
  size?: 'small' | 'medium';
}) {
  const color = STATUS_COLOR[status.color];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        px: size === 'small' ? '8px' : '10px',
        py: size === 'small' ? '3px' : '4px',
        borderRadius: '12px',
        fontSize: size === 'small' ? 11 : 12,
        fontWeight: 500,
        bgcolor: color.bg,
        color: color.fg,
        border: `1px solid ${color.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      {status.name}
    </Box>
  );
}
